module.exports = __webpack_public_path__ + "img/SeasonalGifts.3aaa7567.png";